import React from "react";
import { Link } from "react-router-dom";
import { IconListItem } from "./IconListItem";
import { useFinaidYearId } from "components/hooks/useFinaidYearId";
import { dispatchSlice } from "components/hooks/dispatchSlice";
import { useSlice } from "components/hooks/useSlice";
import { fetchAwardComparison } from "data/actions/awardComparisonActions";
export function AwardComparisonLink() {
  dispatchSlice(fetchAwardComparison);

  const finaidYearId = useFinaidYearId();
  const { loaded, errored, aidYears = [] } = useSlice("awardComparison");

  const matchingAwardComparison = aidYears.find((a) => a.id === finaidYearId);
  const { activityDates = [] } = matchingAwardComparison || {};

  if (loaded && !errored && activityDates.length > 1) {
    return (
      <IconListItem icon="compare">
        <div>
          <strong>Award Comparison</strong>
        </div>
        <Link to={`/finances/finaid/compare/${finaidYearId}`}>
          View Changes to Current Awards
        </Link>
      </IconListItem>
    );
  }

  return null;
}

AwardComparisonLink.displayName = "AwardComparisonLink";
